import apiClient from '@/services/InvoiceapiClient'
export default {
    //<!----------------------------user role page api's-------------------------------->
    /**
     * 
     * @param {*} page 
     * @param {*} count 
     * @param {*} search 
     * @param {*} status 
     */
    getUserRoles(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/userrole/', data)
    },
    postUserRole(form, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/userrole/create', form)
    },
    /**
     * update list api
     * @param {*} id 
     */
    getUserRole(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/userrole/view/' + id)
    },
    /**
     * update api
     * @param {*} form 
     * @param {*} id 
     */
    postUserRoleUpdate(form, id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/userrole/update/' + id, form)
    },
    /**
     * 
     * @param {*} id 
     * @param {*} form 
     */
    getUserRoleDelete(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/userrole/delete', data)
    },
}